export const SET_CAN_CREATE_AD = 'SET_CAN_CREATE_AD'
export const SET_AD_LIST = 'SET_AD_LIST'
